import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ArticleTitle = ({link, textColor, title}) => (
  <h2>
    <Link className={textColor} to={link}>
      {title}
    </Link>
  </h2>
);

ArticleTitle.propTypes = {
  link: PropTypes.string,
  textColor: PropTypes.string
};

export default ArticleTitle;
